import { styled, Box } from '@mui/material';

export const StyledCustomCheckBoxWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  '& > .MuiTypography-root': {
    transform: 'translateY(2px)',
  },
}));
